import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-chart',
  templateUrl: './card-chart.component.html',
  styleUrls: ['./card-chart.component.scss']
})
export class CardChartComponent implements OnInit {

  constructor() { }

  @Input() vm: any;
  @Input() cvm: IChartViewModel;
  @Input() headingSize: number = 5;
  @Input() fullHeader: boolean = true;
  @Input() title: string = '';

  @Output() chartHover = new EventEmitter<{vm: any, cvm: IChartViewModel, event: any}>();
  @Output() chartClick = new EventEmitter<{vm: any, cvm: IChartViewModel, event: any}>();
  @Output() viewDetailsClicked = new EventEmitter<string>();

  displayTitle: string = '';

  ngOnInit(): void {
    this.displayTitle = this.vm?.title?.length ? this.vm.title : this.title;
  }

  /**
   * 
   */
  hover(vm: any, cvm: IChartViewModel, event: any) {
    if (this.cvm.chartHover)
      this.cvm.chartHover(vm, cvm, event);
    else 
      this.chartHover.emit({vm, cvm, event});
  }

  /**
   * 
   * @param vm 
   * @param cvm 
   * @param event 
   */
  clicked(vm: any, cvm: IChartViewModel, event: any) {
    if (this.cvm.chartClick)
      this.cvm.chartClick(vm, cvm, event);
    else 
      this.chartClick.emit({vm, cvm, event});
  }

  details(code: string) {
    this.viewDetailsClicked.emit(code);
  }
}

/**
 * 
 */
export interface IChartViewModel {
  title?: string;
  label?: string;
  chartType?: string;
  chartDatasets?: IChartDatasets[];
  chartLabels?: any[];
  chartColors?: any[];
  chartOptions?: any;
  legend?: boolean;
  clientRoute?: string;

  chartHover?: (vm: any, cvm: IChartViewModel, event: any) => void;
  chartClick?: (vm: any, cvm: IChartViewModel, event: any) => void;

  isDetailsAvailable?: boolean;
}

/**
 * 
 */
export interface IChartDatasets {
  data?: any[];
  label?: string
}
